import React from 'react';
import styled from 'styled-components';
import ContainerDimensions from 'react-container-dimensions';
import { AxisX, AxisY, ChartLine, ChartHover, NoData } from './ChartAxis';
import { config } from './../../config/config';
import { ChartLegend } from './ChartLegend';
import {ButtonPanel} from "../Calculators/ButtonPanel";
import {ButtonLink} from "../Form";

const { colors, titles } = config();

const SvgWrapper = styled.div`
  .x-label { font-family: Ubuntu,arial; font-size: 12px; fill: #000; }
  .y-label { font-family: Ubuntu,arial; font-size: 12px; fill: #000; font-weight: 400; }
  svg .grid-line { stroke: #bbb; }
  svg .grid-line.active { stroke: #62ad4e; }
  svg .r:hover rect { fill: #f8fff8; }
  svg .r .grid-hoverline { display: none; }
  svg .r:hover .grid-hoverline { display: block; }

  svg text.no-data { font-family: Ubuntu,arial; font-size: 22px; font-weight: bold; text-align: center; }
  svg rect.tip { fill: #fff; stroke: #888; box-shadow: 2px 10px 20px #888; stroke-width: 0.5px; color: #888; }
  svg text.legend { font-family: Ubuntu,arial; font-size: 14px; font-weight: normal; }

  table tr th { border-bottom: 1px solid black; }
`;


export const TableSeries = ({ series, input }) => {
  const { futureHousePrice, noRepayments, payingOffInterest, partialRepayment, tableData } = series;

  return (
    <div>
      <table className="dataTable">
        <tr>
          <th style={{width: "10%"}}></th>
          <th>Property value</th>
          <th>Amount owed without making repayments</th>
          <th>Amount owed making repayments</th>
          {input.futureHousePricePct == 0 ? false : (
            <th>Remaining equity without making repayments</th>
          )}
          {input.futureHousePricePct == 0 ? false : (
            <th>Remaining equity making repayments</th>
          )}
        </tr>
        {tableData.map((id, index) => {
          return [(
            <tr>
              <td style={{width: "10%"}}>{id.title}</td>
              <td>
                £{parseFloat(id.propertyValue).toLocaleString()}
              </td>
              <td>
                £{parseFloat(id.amountOwed).toLocaleString()}
              </td>
              <td>
                <strong>£{parseFloat(id.amountOwedPartialRepayments).toLocaleString()}</strong>
              </td>
              {input.futureHousePricePct == 0 ? false : (
                <td>
                  £{parseFloat(id.equity).toLocaleString()}
                </td>
              )}
              {input.futureHousePricePct == 0 ? false : (
                <td>
                  <strong>£{parseFloat(id.equityPartialRepayments).toLocaleString()}</strong>
                </td>
              )}
            </tr>
          )];
        })}
      </table>
      <div className="title"  style={{textAlign: 'center', marginBottom: '40px'}}>
        Figures for illustrative purposes only.
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/PartialRepayment/TableSeries.js